import Authorize from 'components/common/authorize';
import DateRange from 'components/common/date-range';
import InvoicesCard from 'components/dashboard/overview/cards/invoices-card';
import QuotesCard from 'components/dashboard/overview/cards/quotes-card';
import React, { useEffect, useState } from 'react';
import ServiceRequestsCard from 'components/dashboard/overview/cards/service-requests-card';
import _ from 'lodash';
import { CloseX, Ibox } from 'enspire-manager-framework';
import { numPanels } from 'components/common/toolbox';
import { useHistory } from 'react-router-dom';

export default function DashboardOverview(props) {
	
	const history = useHistory();

	const [showAnalytics, setShowAnalytics] = useState(false);
	const [startdate, setStartDate] = useState();
	const [enddate, setEndDate] = useState();

	/* Effects -----------------------------------------------------------------------------------------------------------------*/
	
	useEffect(() => {
		setShowAnalytics(false);
		setTimeout(() => {
			setShowAnalytics(true);
		}, 150);
	}, []);

	const handleDateRange = ({startdate, enddate}) => {
		setStartDate(startdate);
		setEndDate(enddate);
	}

	/* Constants -----------------------------------------------------------------------------------------------------------------*/	

	return (
		<>
			{ showAnalytics &&
				<div className="row">
					<div className="col-12">
						<div id="employee-analytics" className="col-12 mb-3 animated fadeIn">
							{ numPanels(1) && <CloseX onClick={() => history.goBack()} className="mr-3 mt-0" color={ '#aaaaaa' } /> }
							<h1 className="analytics-title">Dashboard Overview</h1>
							<div className="middleOfLine text-muted mt-4 mx-md-4">
								<span className="fa-stack fa-2x">
									<i className="fas fa-circle fa-stack-2x"></i>
									<i className="far fa-clock fa-stack-1x fa-inverse"></i>
								</span>
							</div>
						</div>

						<DateRange {...props} showPresets={true} buttonTitle={'Update Range'} className={'mt-3 mx-md-5'} onChange={ handleDateRange } />
						
						<div className="mt-3 mx-2 mx-md-4">
							<div className="row">
								<div className="col-lg">
									<ServiceRequestsCard startdate={ startdate } enddate={ enddate } />
								</div>
								<Authorize feature={'generate_quotes'}>
									<div className="col-lg">
										<QuotesCard startdate={ startdate } enddate={ enddate } />
									</div>
								</Authorize>
								<Authorize feature={'generate_invoices'}>
									<div className="col-lg">
										<InvoicesCard startdate={ startdate } enddate={ enddate } /> 
									</div>
								</Authorize>
							</div>
							<div className="row">
								{/* <div className="col-lg-12">
									<div className="ibox animated fadeInRight animation-delay-6">
										<div className="ibox-content px-3">
											<div>
												<span className="float-right text-right">
													<small>Average value of sales in the past month in: <strong>United States</strong></small>
													<br />
													All sales: 162,862
												</span>
												<h3 className="font-bold no-margins">
													Half-year revenue margin
												</h3>
												<small>Sales marketing.</small>
											</div>

											<div className="m-t-sm">
												<div className="row">
													<div className="col-md-8">
														<div>
															<canvas id="lineChart" height="253" width="668" style={{ display: 'block', height: '203px', width: '535px' }}></canvas>
														</div>
													</div>
													<div className="col-md-4">
														<ul className="stat-list m-t-lg">
															<li>
																<h2 className="no-margins">2,346</h2>
																<small>Total orders in period</small>
																<div className="progress progress-mini">
																	<div className="progress-bar" style={{ width: '48%' }}></div>
																</div>
															</li>
															<li>
																<h2 className="no-margins">4,422</h2>
																<small>Orders in last month</small>
																<div className="progress progress-mini">
																	<div className="progress-bar" style={{ width: '60%' }}></div>
																</div>
															</li>
														</ul>
													</div>
												</div>
											</div>
											<div className="m-t-md">
												<small className="float-right">
													<i className="fa fa-clock-o"></i>
													Update on 16.07.2015
												</small>
												<small>
													<strong>Analysis of sales:</strong> The value has been changed over time, and last month reached a level over $50,000.
												</small>
											</div>
										</div>
									</div>
								</div> */}
							</div>
						</div>
					</div>
				</div>
			}
		</>
	);
};

